import React, {useState, useEffect} from 'react';
import PageContent from "../../../components/page-content/page-content";
import {Button, Card, Col, Row, Space, Table, Tag, Select, Input, message, Modal, Radio} from "antd";
import {PlusOutlined, EditOutlined, DeleteOutlined} from "@ant-design/icons";
import {getOrders, deleteOrder} from "../../../lib/api_cw_orders";
import OrderPosModal from "./orders_pos_modal";
import OrderEditPosModal from "./orders_edit_pos_modal";
import moment from "moment";

const {Column} = Table;
const {Search} = Input;
const {Option} = Select;

const Orders = () => {
    const [list, setList] = useState([]);
    const [showAddModal, setShowAddModal] = useState(false);
    const [editId, setEditId] = useState(null);

    const [searchText, setSearchText] = useState('');
    const [storeFilter, setStoreFilter] = useState('');
    const [tableParams, setTableParams] = useState({
        pagination: {
            current: 1,
            pageSize: 20,
        },
    });

    const orderStatusMap = {
        1: {text: '待支付', color: 'orange'},
        2: {text: '已支付', color: 'blue'},
        3: {text: '已完成', color: 'green'},
        4: {text: '已取消', color: 'red'},
    };

    const fetchData = () => {
        getOrders(tableParams.pagination.current, tableParams.pagination.pageSize, searchText, storeFilter)
            .then((res) => {
                if (res.code === 0) {
                    setList(res.data.list || []);
                    setTableParams({
                        ...tableParams,
                        pagination: {
                            ...tableParams.pagination,
                            total: res.data.total || 0,
                        },
                    });
                }
            })
            .catch((error) => {
                message.error('获取订单列表失败');
            });
    };

    useEffect(fetchData, [JSON.stringify(tableParams), searchText, storeFilter]);

    const handleTableChange = (pagination, filters, sorter) => {
        setTableParams({
            pagination,
            filters,
            ...sorter,
        });
    };

    const handleDelete = (id, orderNo) => {
        Modal.confirm({
            title: '确认删除',
            content: `确定要删除订单 ${orderNo} 吗？`,
            okText: '确认',
            cancelText: '取消',
            onOk: () => {
                deleteOrder(id)
                    .then((res) => {
                        if (res.code === 0) {
                            message.success('删除成功');
                            fetchData();
                        } else {
                            message.error(res.message || '删除失败');
                        }
                    })
                    .catch(() => {
                        message.error('删除失败');
                    });
            }
        });
    };

    const handleSearch = (value) => {
        setSearchText(value);
        setTableParams(prev => ({
            ...prev,
            pagination: {
                ...prev.pagination,
                current: 1,
            },
        }));
    };

    const handleStoreFilterChange = (value) => {
        setStoreFilter(value);
        setTableParams(prev => ({
            ...prev,
            pagination: {
                ...prev.pagination,
                current: 1,
            },
        }));
    };

    return (
        <PageContent>
            <Card title={"订单管理"}>
                <Row justify="space-between" style={{marginBottom: 16}}>
                    <Col>
                        <Space>
                            <Search
                                placeholder="搜索订单号"
                                allowClear
                                onSearch={handleSearch}
                                style={{width: 300}}
                            />
                            <Radio.Group 
                                value={storeFilter}
                                onChange={(e) => handleStoreFilterChange(e.target.value)}
                                optionType="button"
                                buttonStyle="solid"
                            >
                                <Radio.Button value="">全部门店</Radio.Button>
                                <Radio.Button value="门店1">门店1</Radio.Button>
                                <Radio.Button value="门店2">门店2</Radio.Button>
                            </Radio.Group>
                        </Space>
                    </Col>
                    <Col>
                        <Button type="primary" icon={<PlusOutlined/>} onClick={() => setShowAddModal(true)}>
                            新增订单
                        </Button>
                    </Col>
                </Row>

                <Table
                    dataSource={list}
                    rowKey="id"
                    pagination={{
                        ...tableParams.pagination,
                        showSizeChanger: true,
                        pageSizeOptions: ['10', '20', '50', '100'],
                        showTotal: (total) => `共 ${total} 条`
                    }}
                    onChange={handleTableChange}
                    size="small"
                >
                    <Column
                        title="订单号"
                        dataIndex="order_no"
                        key="order_no"
                        width={140}
                    />
                    <Column
                        title="门店"
                        dataIndex="md"
                        key="md"
                        width={100}
                        render={(md) => md || '未知门店'}
                    />
                    <Column
                        title="订单日期"
                        dataIndex="order_date"
                        key="order_date"
                        width={100}
                        render={(date) => date ? moment(date).format('YYYY-MM-DD') : '-'}
                    />
                    <Column
                        title="原价金额"
                        dataIndex="original_amount"
                        key="original_amount"
                        width={100}
                        render={(amount) => amount ? `¥${parseFloat(amount).toFixed(2)}` : '¥0.00'}
                    />
                    <Column
                        title="优惠金额"
                        dataIndex="discount_amount"
                        key="discount_amount"
                        width={100}
                        render={(amount) => amount ? `¥${parseFloat(amount).toFixed(2)}` : '¥0.00'}
                    />
                    <Column
                        title="实际支付"
                        dataIndex="actual_amount"
                        key="actual_amount"
                        width={100}
                        render={(amount) => amount ? `¥${parseFloat(amount).toFixed(2)}` : '¥0.00'}
                    />
                    <Column
                        title="备注"
                        dataIndex="remark"
                        key="remark"
                        ellipsis
                        render={(remark) => remark || '-'}
                    />
                    <Column
                        title="操作"
                        key="action"
                        width={180}
                        render={(text, record) => (
                            <Space>
                                <Button
                                    type="link"
                                    icon={<EditOutlined/>}
                                    size="small"
                                    onClick={() => setEditId(record.id)}
                                >
                                    编辑
                                </Button>
                                <Button
                                    type="link"
                                    danger
                                    icon={<DeleteOutlined/>}
                                    size="small"
                                    onClick={() => handleDelete(record.id, record.order_no)}
                                >
                                    删除
                                </Button>
                            </Space>
                        )}
                    />
                </Table>
            </Card>

            {showAddModal && (
                <OrderPosModal
                    onOk={() => {
                        setShowAddModal(false);
                        fetchData();
                    }}
                    onCancel={() => setShowAddModal(false)}
                />
            )}

            {editId && (
                <OrderEditPosModal
                    id={editId}
                    onOk={() => {
                        setEditId(null);
                        fetchData();
                    }}
                    onCancel={() => setEditId(null)}
                />
            )}


        </PageContent>
    );
};

export default Orders;